import React from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { store } from "./redux/store";
import { persistStore } from "redux-persist";
import { PersistGate } from "redux-persist/integration/react";
import { Provider } from "react-redux";

import "./index.css";
import "languages/i18n";
import { LoggingProvider } from "./logging";
import CustomerPortal from "./CustomerPortal";
import AgentPortal from "./AgentPortal";
import ChaseHHPCCInfo from "./routes/ChasePayment/ChaseHPPTemplateCCInfo";
import reportWebVitals from "./reportWebVitals";
import PostSurvey from "./components/Survey/PostSurvey";
import { isAgentPortal } from "js/utilities";
import LanguageProvider from "languages/LanguageProvider";
import ErrorBoundary from "components/ErrorBoundary/ErrorBoundary";
import DataProvider from "context/Agent/DataProvider";
import { ChatProvider } from "context/Agent/ChatProvider";

const persistor = persistStore(store);
const container = document.getElementById("root");
const root = createRoot(container); // createRoot(container!) if you use TypeScript

// check agent prefix
if (window.location.pathname.split("/")[1] === "chasehpptemplateccinfo") {
  root.render(<ChaseHHPCCInfo />);
} else if (isAgentPortal()) {
  // add in agent prefix for all routes
  root.render(
    <Provider store={store}>
      <ErrorBoundary isAgentPortal>
        <PersistGate loading={null} persistor={persistor}>
          <LanguageProvider>
            <BrowserRouter>
              <DataProvider>
                <ChatProvider>
                  <LoggingProvider portal="Agent">
                    <Routes>
                      <Route
                        path="survey"
                        element={<PostSurvey groupName="Post Chat Survey" />}
                      />
                      <Route path="*" element={<AgentPortal />} />
                    </Routes>
                  </LoggingProvider>
                </ChatProvider>
              </DataProvider>
            </BrowserRouter>
          </LanguageProvider>
        </PersistGate>
      </ErrorBoundary>
    </Provider>
  );
} else {
  root.render(
    <Provider store={store}>
      <ErrorBoundary>
        <PersistGate loading={null} persistor={persistor}>
          <LanguageProvider>
            <BrowserRouter>
              <LoggingProvider portal="Customer">
                <ChatProvider>
                  <Routes>
                    <Route
                      path="survey"
                      element={
                        <PostSurvey groupName="Post Chat Survey-Customer" />
                      }
                    />
                    <Route path="*" element={<CustomerPortal />} />
                  </Routes>
                </ChatProvider>
              </LoggingProvider>
            </BrowserRouter>
          </LanguageProvider>
        </PersistGate>
      </ErrorBoundary>
    </Provider>
  );
}

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
